import { get, post } from "shared/data";
import { objectToParamString } from "shared/helpers";

export const searchProducts = (params) => {
    return get(`/tasking/contexts?${objectToParamString(params)}`);
};

export const searchProductsReq = (params) => {
    return get(`/tasking/contexts/v2?${objectToParamString(params)}`);
};

export const searchNewProducts = (params, source, includeTrackingNumbers) => {
    const queryString = includeTrackingNumbers ? `includeTrackingNumbers=true` : "";
    const sourcePage = source ? `sourcePage=${source}&` : "";

    return post(`/tasking/contexts/search/v2?${sourcePage}${queryString}`, params);
};
